import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';

// PACKAGES
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../components/Button';
import LoadingSpinner from '../../components/LoadingSpinner';

// ICONS
import { ReactComponent as AlertIcon } from '../../assets/svg/alert.svg';

// TYPES
import { ComplaintAdviceDashboardComplaintAdvice } from '../../api/models';
import { closeModalType } from '../../components/GlobalModal';

interface RemoveModalTypes {
	getComplaintsAdviceData: () => Promise<void>;
	complaintsAdviceData: ComplaintAdviceDashboardComplaintAdvice[];
	setComplaintsAdviceData: React.Dispatch<React.SetStateAction<ComplaintAdviceDashboardComplaintAdvice[]>>;
	adviceId?: string;
	adviceTitle?: string;
	closeModal?: closeModalType;
}

const RemoveModal: React.FC<RemoveModalTypes> = ({
	closeModal,
	getComplaintsAdviceData,
	complaintsAdviceData,
	setComplaintsAdviceData,
	adviceId,
	adviceTitle
}) => {
	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const removeAdvice = async () => {
		setIsLoading(true);

		const newData = complaintsAdviceData.filter((item) => item.id !== adviceId);
		setComplaintsAdviceData(newData);

		const response = await apibridge.postComplaintAdviceDelete({ id: adviceId });

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			if (closeModal) {
				closeModal();
			}

			getComplaintsAdviceData();
		}
	};

	return (
		<div className="modal-confirmation">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<h2 className="heading h4">
									Are you sure you wish to remove <strong> '{adviceTitle}'?</strong>
								</h2>

								<section className="actions">
									<Button className="btn-primary full-width" onClick={removeAdvice}>
										Yes
									</Button>

									<Button className="btn-secondary full-width" onClick={closeModal}>
										Cancel
									</Button>
								</section>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default RemoveModal;
